import { render } from "./callToActionCenteredDivideBlock.vue?vue&type=template&id=38dcd120&scoped=true&ts=true"
import script from "./callToActionCenteredDivideBlock.vue?vue&type=script&lang=ts"
export * from "./callToActionCenteredDivideBlock.vue?vue&type=script&lang=ts"

import "./callToActionCenteredDivideBlock.vue?vue&type=style&index=0&id=38dcd120&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38dcd120"]])

export default __exports__